import React from 'react';
import {
  ReportSection,
  RestoreAllDataButton,
  ThumbRatingContainer,
} from '@/reports/index';
import { peopleTypes } from '@/reports/types';
import { JobCard } from './JobCard';

export interface JobSectionProps {
  personName: string;
  jobs: peopleTypes.Jobs;
  permalink: string;
}

export function JobSection({ personName, jobs, permalink }: JobSectionProps) {
  return (
    <ReportSection
      title="Possible Jobs"
      sectionDescription={`Any jobs positions that ${personName} currently or previously held that are documented on publicly accessible sources are shown below:`}
      sectionId="jobs-section"
      hasContent={jobs.length > 0}
      personName={personName}
    >
      {jobs.map((job, index: number) => (
        <ThumbRatingContainer
          key={index}
          item={job}
          dataPropKey="job"
          permalink={permalink}
          component={JobCard}
        />
      ))}
      <RestoreAllDataButton items={jobs} permalink={permalink} />
    </ReportSection>
  );
}
